'use client';
import styled, { css } from 'styled-components';

const stretchToParent = css`
  width: 100%;
  max-width: 100%;

  & > * {
    width: 100%;
    max-width: 100%;
  }
`;

const isFullWidthMobile = ({ $fullWidth, $fullWidthMobile }) =>
  Boolean($fullWidth || $fullWidthMobile);

const isFullWidthDesktop = ({ $fullWidth, $fullWidthDesktop }) =>
  Boolean($fullWidth || $fullWidthDesktop);

export const StyledCtaShell = styled.div`
  box-sizing: border-box;
  background-color: transparent;
  ${props => props.theme.getFocusOutline()}

  ${props =>
    isFullWidthMobile(props)
      ? stretchToParent
      : css`
          width: ${props.$defaultWidth || 'fit-content'};
          max-width: 100%;

          ${props.$defaultWidth &&
          css`
            & > * {
              width: 100%;
            }
          `}
        `}

  @media ${props => props.theme.tablet} {
    ${props =>
      isFullWidthDesktop(props)
        ? stretchToParent
        : css`
            width: ${props.$defaultWidth || 'fit-content'};
            max-width: 100%;

            & > * {
              width: ${props.$defaultWidth ? '100%' : 'auto'};
            }
          `}
  }
`;
